const calcuableMonetaryIncentives = new Set(["REBATE", "TAX CREDIT", "TAX EXEMPTION"]);
export default calcuableMonetaryIncentives;